import React from 'react';
const services = [{
  id: 'studie-a-konzultace',
  label: 'studie a konzultace'
}, {
  id: 'projekce',
  label: 'projekce'
}, {
  id: 'projektove-rizeni',
  label: 'projektové řízení'
}, {
  id: 'realizace',
  label: 'realizace'
}, {
  id: 'sw-a-it',
  label: 'SW a IT'
}, {
  id: 'servis-a-podpora',
  label: 'servis a podpora'
}, {
  id: 'market-focus',
  label: 'market focus'
}];
export function ServicesSolutions() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 120; // offset for sticky header
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  };
  return <section id="sluzby" className="w-full bg-white py-12" data-id="element-230">
      <div className="max-w-6xl mx-auto px-6" data-id="element-231">
        {/* Top Overview */}
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.6fr] gap-16 items-start mb-24" data-id="element-232">
          {/* Left Column - Services List */}
          <div className="flex flex-col items-end text-right" data-id="element-233">
            <h2 className="text-2xl font-normal text-[#707070] tracking-wide mb-2" data-id="element-234">
              SLUŽBY
            </h2>
            <p className="text-[#999] font-light mb-8" data-id="element-235">
              Od studie po servis a podporu
            </p>
            <ul className="space-y-2" data-id="element-236">
              {services.map(service => <li key={service.id} data-id="element-237">
                  <a href={`#${service.id}`} onClick={e => handleScroll(e, service.id)} className="flex items-center justify-end gap-3 text-[#707070] hover:text-[#404040] transition-colors group py-1" data-id="element-238">
                    <span className="text-base" data-id="element-239">{service.label}</span>
                    <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 group-hover:opacity-100 transition-opacity scale-x-[-1]" data-id="element-240" />
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Right Column - SVG Illustration */}
          <div className="w-full flex items-center justify-center py-8" data-id="element-241">
            <img src="https://cdn.magicpatterns.com/uploads/99M8AaifK4Np5aajqGFYJE/sluzby.svg" alt="Služby" className="h-52 md:h-[17rem] w-auto object-contain opacity-[0.44]" data-id="element-242" />
          </div>
        </div>

        {/* Detailed Sections */}
        <div className="space-y-16 lg:pl-[100px]" data-id="element-243">
          {/* 1. studie a konzultace */}
          <div id="studie-a-konzultace" className="border-t border-gray-200 pt-16" data-id="element-244">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-245">
              studie a konzultace
            </h3>
            <div className="space-y-4 text-[#707070] leading-relaxed" data-id="element-246">
              <p data-id="element-247">
                Správné zadání je základ pro kvalitní projektovou dokumentaci. A
                pro správné zadání je potřeba přijít na to, co potřebujete. Na
                základě společných rozhovorů, vašich představa o řešení, a s
                našimi zkušenostmi, dáme dohromady studii k vašemu projektu. Ta
                pomůže k upřesnění zadání a vyjasnění, co by měl být výsledek.
              </p>
            </div>
          </div>

          {/* 2. projekce */}
          <div id="projekce" className="border-t border-gray-200 pt-16" data-id="element-248">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-249">
              projekce
            </h3>
            <div className="space-y-4 text-[#707070] leading-relaxed" data-id="element-250">
              <p data-id="element-251">
                I malý projekt musí být správně a pečlivě připraven. A co teprve
                ten velký. Kvalitní projektová dokumentace znamená jasnou
                představu o postupu i požadovaném výsledku. Znamená i přesnější
                rozpočet, plán práce, a je nedílnou součástí celého díla.
              </p>
              <p data-id="element-252">
                Zpracujeme pro vás projekt pro všechny nabízené technologie –
                elektro silnoproud, slaboproudé systémy, audiovizuální řešení,
                řídící systémy (MaR, BMS).
              </p>
              <p data-id="element-253">
                Detailní zpracování projektové dokumentace včetně blokových
                schémat. Součástí je i koordinace s ostatními profesemi. Řešení
                návazností je důležité pro minimalizaci rizik.
              </p>
            </div>
          </div>

          {/* 3. projektové řízení */}
          <div id="projektove-rizeni" className="border-t border-gray-200 pt-16" data-id="element-254">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-255">
              projektové řízení
            </h3>
            <div className="space-y-4 text-[#707070] leading-relaxed" data-id="element-256">
              <p data-id="element-257">
                Každá realizace musí být naplánovaná. Příprava materiálu,
                koordinace na místě realizace, správné načasování, sestavení
                realizačního týmu. Přípravné práce jsou základem pro efektivní
                realizaci. I když je naše část třeba až na konci stavby, je
                důležité hlídat připravenost. Na našich projektech si dáváme
                velmi záležet na spolupráci s ostatními profesemi, a i díky tomu
                jsou pak samotné realizace rychlé a efektivní.
              </p>
              <p data-id="element-258">
                Projektový manažer není jen přeposílač emailů, a plánovač
                schůzek. Je to klíčová osoba pro komunikaci mezi kliente,
                ostatními dodavateli, a realizačním týmem.
              </p>
            </div>
          </div>

          {/* 4. realizace */}
          <div id="realizace" className="border-t border-gray-200 pt-16" data-id="element-259">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-260">
              realizace
            </h3>
            <div className="space-y-4 text-[#707070] leading-relaxed" data-id="element-261">
              <p data-id="element-262">
                Máme kvalitní realizační tým se zkušenostmi, zázemím, kvalitními
                nástroji, s projektovou podporou, a systémem řízení a sdílení
                informací. Naši kolegové mají informace o aktuálních produktech
                a novinkách, a jsou školeni v rámci týmu, i od výrobců, aby
                věděli, co dělat To vše pak znamená rychle a kvalitně
                realizované zakázky.
              </p>
              <p data-id="element-263">
                Máme několik týmů, pro jednotlivé typy projektů, ale často
                pracují společně, nebo jejich práce na sebe navazuje, a i proto
                mají větší přehled a zkušenosti.
              </p>
            </div>
          </div>

          {/* 5. SW a IT */}
          <div id="sw-a-it" className="border-t border-gray-200 pt-16" data-id="element-264">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-265">
              SW a IT
            </h3>
            <div className="space-y-4 text-[#707070] leading-relaxed" data-id="element-266">
              <p data-id="element-267">
                Součástí našich projektů jsou i SW a IT práce – nastavení
                zařízení, konfigurace, programování ovládání, grafika pro
                uživatelské rozhraní, nastavení nejrůznějších systémů. Je to
                velké spektrum práce, na které je potřeba hodně zkušeností. Máme
                velký IT a SW tým, který se věnuje zakázkám dle potřeby – od
                studie, přes projektovou dokumentaci, až po samotnou realizaci.
                Během ní jsou pak v úzké komunikaci s klientem, aby byla bez
                problémů nejen implementace, ale i předání a zaškolení.
              </p>
            </div>
          </div>

          {/* 6. servis a podpora */}
          <div id="servis-a-podpora" className="border-t border-gray-200 pt-16" data-id="element-268">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-269">
              servis a podpora
            </h3>
            <div className="space-y-4 text-[#707070] leading-relaxed" data-id="element-270">
              <p data-id="element-271">
                Každý systém vyžaduje péči, a údržbu. A to vyžaduje zkušenosti.
                Naučíme vás. Jak se o dodané systémy starat, nebo vám s tím
                můžeme pomáhat. A když budete chtít, nebo nebudete mít kapacity,
                postaráme se o všechno. Nabízíme i pravidelné zaškolení na
                používání pro koncové uživatele, aby se s postupem let při
                fluktuaci zaměstnanců stále udržovala znalostní báze.
              </p>
              <p data-id="element-272">
                Součástí našich služeb je i nadstandardní záruční i pozáruční
                servis, podpora (v úrovni dle dohodnuté servisní smlouvy), i s
                možností náhradního zařízení a dalších služeb.
              </p>
            </div>
          </div>

          {/* 7. market focus */}
          <div id="market-focus" className="border-t border-gray-200 pt-16" data-id="element-273">
            <h3 className="text-xl font-normal text-[#707070] tracking-wide uppercase mb-6" data-id="element-274">
              market focus
            </h3>
            <div className="space-y-6 text-[#707070] leading-relaxed" data-id="element-275">
              <p data-id="element-276">
                Naše portfolio je velmi široké, a naše aktivity směřují do
                různých typů projektů. Postupem času se stále rozšiřuje a díky
                tomu nacházíme uplatnění v široké škále projektů.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-277">
                <div data-id="element-278">
                  <h4 className="font-medium mb-3" data-id="element-279">Rezidenční projekty</h4>
                  <ul className="space-y-2" data-id="element-280">
                    <li className="flex items-start gap-3" data-id="element-281">
                      <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 mt-2" data-id="element-282" />
                      <span data-id="element-283">bytové domy</span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-284">
                      <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 mt-2" data-id="element-285" />
                      <span data-id="element-286">individuální výstavba – luxusní domy a byty</span>
                    </li>
                  </ul>
                </div>

                <div data-id="element-287">
                  <h4 className="font-medium mb-3" data-id="element-288">Komerční AV projekty</h4>
                  <ul className="space-y-2" data-id="element-289">
                    <li className="flex items-start gap-3" data-id="element-290">
                      <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 mt-2" data-id="element-291" />
                      <span data-id="element-292">kanceláře</span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-293">
                      <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 mt-2" data-id="element-294" />
                      <span data-id="element-295">eventové prostory</span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-296">
                      <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 mt-2" data-id="element-297" />
                      <span data-id="element-298">konferenční hotely</span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-299">
                      <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 mt-2" data-id="element-300" />
                      <span data-id="element-301">retail</span>
                    </li>
                  </ul>
                </div>

                <div data-id="element-302">
                  <h4 className="font-medium mb-3" data-id="element-303">Komerční objekty</h4>
                  <ul className="space-y-2" data-id="element-304">
                    <li className="flex items-start gap-3" data-id="element-305">
                      <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 mt-2" data-id="element-306" />
                      <span data-id="element-307">obchodní centra</span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-308">
                      <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 mt-2" data-id="element-309" />
                      <span data-id="element-310">administrativní objekty</span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-311">
                      <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 mt-2" data-id="element-312" />
                      <span data-id="element-313">retail</span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-314">
                      <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 mt-2" data-id="element-315" />
                      <span data-id="element-316">hotely a restaurace</span>
                    </li>
                  </ul>
                </div>

                <div data-id="element-317">
                  <h4 className="font-medium mb-3" data-id="element-318">
                    Veřejné objekty a instituce
                  </h4>
                  <ul className="space-y-2" data-id="element-319">
                    <li className="flex items-start gap-3" data-id="element-320">
                      <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 mt-2" data-id="element-321" />
                      <span data-id="element-322">školy</span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-323">
                      <img src="https://cdn.magicpatterns.com/uploads/ngsUE6r4TLTc8etnh6qeyU/sipka.png" alt="" className="h-[10px] w-auto opacity-60 mt-2" data-id="element-324" />
                      <span data-id="element-325">muzea</span>
                    </li>
                  </ul>
                </div>
              </div>

              <p className="pt-4" data-id="element-326">
                Projekty realizujeme převážně v České republice, ale řada našich
                komerčních projektů je realizovaná i za hranicemi, celkem ve
                více 15-ti zemích, především v Evropě. Obvykle je to v rámci
                jednotného standardu firem pro audiovizuální a konferenční
                techniku.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}